module.exports = __webpack_public_path__ + "static/feedback@2x-9ed495270174fa0a3d21e37b205a876f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/consultancies/feedback@2x.jpg
// module id = 2542
// module chunks = 56719701542624